/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpgradeSubscriptionResponse interface.
 */
export function instanceOfUpgradeSubscriptionResponse(value) {
    if (!('bonusCreditsGranted' in value) || value['bonusCreditsGranted'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    return true;
}
export function UpgradeSubscriptionResponseFromJSON(json) {
    return UpgradeSubscriptionResponseFromJSONTyped(json, false);
}
export function UpgradeSubscriptionResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bonusCreditsGranted': json['bonus_credits_granted'],
        'status': json['status'],
        'tier': json['tier'],
    };
}
export function UpgradeSubscriptionResponseToJSON(json) {
    return UpgradeSubscriptionResponseToJSONTyped(json, false);
}
export function UpgradeSubscriptionResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'bonus_credits_granted': value['bonusCreditsGranted'],
        'status': value['status'],
        'tier': value['tier'],
    };
}
